module.exports = __webpack_public_path__ + "static/media/job_cleaning_type.e551eb72.svg";